import type { VoidFunctionComponent } from 'react';

type Props = {
  isSmallIcon?: boolean;
};

/* eslint-disable react/no-unknown-property */
const GitIcon: VoidFunctionComponent<Props> = ({ isSmallIcon }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={isSmallIcon ? 12 : 16} height={isSmallIcon ? 12 : 16} fill="none" viewBox="0 0 80 80"><g clip-path="url(#a)"><path fill="#F05133" d="M78.495 36.437 43.563 1.509a5.151 5.151 0 0 0-7.285 0l-7.254 7.254 9.2 9.2a6.116 6.116 0 0 1 7.75 7.8l8.867 8.868a6.12 6.12 0 0 1 6.334 1.455 6.128 6.128 0 0 1 0 8.669 6.13 6.13 0 0 1-10.006-6.667l-8.27-8.27-.001 21.762a6.132 6.132 0 1 1-7.047 9.83 6.131 6.131 0 0 1 2.007-10.008V29.437A6.049 6.049 0 0 1 35.85 28.1a6.129 6.129 0 0 1-1.32-6.702l-9.07-9.071-23.95 23.95a5.153 5.153 0 0 0 0 7.287l34.93 34.928a5.153 5.153 0 0 0 7.286 0l34.768-34.763a5.155 5.155 0 0 0 0-7.288" /></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h80v80H0z" /></clipPath></defs></svg>
  );
};

export default GitIcon;
